"use client"
import Image from "next/image"

const GALLERY_Images = [
    "/images/Class-room.webp",
    "/images/computerlab.webp",
    "/images/sci_lab.webp",
    "/images/library.webp",
    "/images/sports.webp",
    "/images/student-council.webp",
    "/images/playground.webp",
    "/images/gallery1.webp",
    "/images/gallery2.webp",
    "/images/gallery3.webp",
    "/images/gallery4.webp",
    "/images/gallery5.webp",
    "/images/gallery6.webp",
    "/images/gallery7.webp",
    "/images/gallery8.webp",
]

export function InfiniteGallery() {
    return (
        <section className="py-16 bg-white overflow-hidden">
            <div className="container mx-auto px-4 mb-10 text-center">
                <h2 className="text-3xl font-bold font-serif text-[#002855] mb-4">Glimpses of Excellence</h2>
                <p className="text-muted-foreground max-w-2xl mx-auto text-lg">
                    Capturing the vibrant moments and facilities that make our school a hub of learning and joy.
                </p>
            </div>

            <div className="relative w-full flex overflow-hidden group">
                <div className="flex animate-marquee min-w-full shrink-0 gap-6 items-center py-4">
                    {GALLERY_Images.map((src, index) => (
                        <div
                            key={`gallery-1-${index}`}
                            className="relative w-[300px] h-[200px] sm:w-[350px] sm:h-[240px] shrink-0 rounded-2xl overflow-hidden shadow-md hover:shadow-xl transition-shadow duration-300 border border-gray-100"
                        >
                            <Image
                                src={src}
                                alt={`School Gallery Image ${index + 1}`}
                                fill
                                className="object-cover hover:scale-110 transition-transform duration-500"
                                sizes="(max-width: 640px) 300px, 350px"
                            />
                        </div>
                    ))}
                </div>

                {/* Duplicate for seamless loop */}
                <div aria-hidden="true" className="flex animate-marquee min-w-full shrink-0 gap-6 items-center py-4">
                    {GALLERY_Images.map((src, index) => (
                        <div
                            key={`gallery-2-${index}`}
                            className="relative w-[300px] h-[200px] sm:w-[350px] sm:h-[240px] shrink-0 rounded-2xl overflow-hidden shadow-md hover:shadow-xl transition-shadow duration-300 border border-gray-100"
                        >
                            <Image
                                src={src}
                                alt={`School Gallery Image ${index + 1}`}
                                fill
                                className="object-cover hover:scale-110 transition-transform duration-500"
                                sizes="(max-width: 640px) 300px, 350px"
                            />
                        </div>
                    ))}
                </div>
            </div>
        </section>
    )
}
